var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKbMonogramma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 116,
    viewBox: "0 0 209 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66317 107.936C4.86934 107.936 3.8472 106.845 4.01756 104.271C4.52863 97.079 10.917 4.31215 11.1384 3.71563C11.4168 3.06224 11.8992 2.51658 12.5133 2.16021C13.1275 1.80385 13.8404 1.65594 14.5455 1.7386C17.629 1.72156 34.4771 1.7386 34.6645 1.7386C37.305 1.7386 38.242 2.38625 38.259 5.14727C38.259 7.27769 36.5555 36.916 36.3511 39.1317C36.2876 39.6125 36.0931 40.0665 35.7889 40.444C33.2165 43.597 30.6782 47.7215 28.0036 50.8064C27.2635 51.5089 26.805 52.4574 26.7141 53.474C26.6231 54.4906 26.906 55.5055 27.5096 56.3284C29.8775 60.4529 31.9899 62.8219 34.1875 67.0316C34.3238 67.2873 31.8366 101.936 31.513 104.68C31.1893 107.424 30.2523 107.919 27.714 107.919C24.4432 107.953 10.9681 107.953 7.66317 107.936Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8105 107.952C74.3063 107.952 73.2671 106.998 73.4034 104.731C73.6589 100.078 77.8667 38.2622 78.3437 32.0755C78.3437 31.4449 90.9671 12.8165 96.8784 4.07329C97.3074 3.36015 97.9272 2.78118 98.6677 2.40173C99.4082 2.02227 100.24 1.85744 101.069 1.92583C110.183 1.92583 119.297 1.92583 128.411 1.92583C134.413 1.76752 140.393 2.7031 146.06 4.68685C155.225 8.19778 160.404 14.6061 161.92 23.5368C163.193 29.7969 162.228 36.3053 159.194 41.9265C157.005 46.3494 153.507 49.991 149.178 52.3571C148.922 52.4764 148.581 52.715 148.581 52.9025C148.581 53.0899 148.888 53.3797 149.143 53.4819C156.758 56.3622 160.557 61.0662 161.92 68.1562C163.464 75.3501 162.382 82.8591 158.871 89.3241C153.76 98.7831 145.242 104.441 134.101 106.947C130.862 107.66 127.554 108.009 124.237 107.987L76.8105 107.952ZM132.074 81.7057C133.118 80.0974 133.8 78.2814 134.074 76.3834C134.347 74.4854 134.205 72.5506 133.658 70.7127C133.232 68.9986 132.32 67.4439 131.033 66.2348C129.746 65.0256 128.138 64.2134 126.401 63.8954C125.413 63.6738 103.914 63.4523 103.727 63.4864C103.199 71.224 102.67 78.9447 102.142 86.7846C102.585 86.7846 122.295 86.7846 123.573 86.5801C125.276 86.5116 126.938 86.0365 128.419 85.1944C129.901 84.3524 131.16 83.1679 132.091 81.7398L132.074 81.7057ZM105.124 42.8639H105.72C111.393 42.8639 117.048 42.8639 122.755 42.8639C129.57 42.7276 134.22 38.1429 133.948 31.8198C133.76 27.3886 131.001 24.3889 126.248 23.5027C125.123 23.2974 123.983 23.1891 122.841 23.1789C117.645 23.1789 112.432 23.1789 107.236 23.1789H106.384C106.009 29.7576 105.567 36.2682 105.124 42.8639Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.953 104.186C139.288 105.635 139.953 106.759 141.656 107.083C142.133 107.168 157.601 107.22 164.842 107.237C166.394 107.292 167.938 106.98 169.347 106.325C170.756 105.671 171.991 104.692 172.95 103.47C181.298 93.2441 204.313 55.5272 204.415 54.7602C204.474 54.3092 204.439 53.8508 204.313 53.4138C204.194 52.9707 186.46 23.3493 177.397 6.10149C176.641 4.455 175.396 3.08117 173.833 2.16647C172.27 1.25176 170.463 0.840495 168.658 0.988486C166.528 1.02257 147.159 1.19301 146.988 1.22709C146.587 1.3183 146.21 1.49549 145.884 1.74643C145.558 1.99738 145.29 2.31611 145.099 2.68065C144.908 3.04519 144.798 3.44685 144.777 3.85795C144.757 4.26904 144.825 4.67979 144.978 5.06184C145.063 5.38567 166.579 42.2163 171.962 52.4594C172.165 52.8028 172.298 53.1828 172.353 53.5776C172.409 53.9724 172.386 54.3742 172.286 54.7602C172.184 55.2033 140.174 103.658 139.953 104.186Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9125 4.77216C97.5939 3.32348 96.9125 2.21566 95.2089 1.89183C94.749 1.78957 79.2807 1.73844 72.0406 1.73844C70.4896 1.68236 68.9472 1.99261 67.5384 2.64404C66.1296 3.29547 64.8939 4.26976 63.9316 5.48798C56.0101 15.1345 34.6646 47.568 31.7515 50.9937C31.1536 51.6253 30.7564 52.4201 30.6101 53.2775C30.5426 53.7283 30.5776 54.1885 30.7123 54.6239C30.8495 55.1118 31.0684 55.5728 31.3597 55.9874C31.7174 56.5157 50.4224 85.6258 59.4854 102.857C60.2395 104.505 61.4834 105.88 63.0473 106.795C64.6112 107.71 66.4191 108.12 68.2246 107.97C70.337 107.97 89.7064 107.799 89.8427 107.765C90.2455 107.677 90.624 107.501 90.9517 107.251C91.2795 107 91.5485 106.681 91.7401 106.316C91.9316 105.951 92.0409 105.548 92.0604 105.136C92.0799 104.724 92.0091 104.312 91.8529 103.93C91.7677 103.572 68.395 65.7873 63.0117 55.5613C62.8057 55.2194 62.6709 54.8393 62.6153 54.4439C62.5597 54.0486 62.5844 53.646 62.688 53.2605C62.8073 52.8344 96.674 5.3005 96.9125 4.77216Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.000488281,
    y: 0.958984,
    width: 208.443,
    height: 115.041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.99951,
    y1: 1.71625,
    x2: 3.99951,
    y2: 107.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 73.3916,
    y1: 1.90863,
    x2: 73.3916,
    y2: 107.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 284845,
    y1: 84843.2,
    x2: 289784,
    y2: 88426.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA371"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 291234,
    y1: 75782.5,
    x2: 297493,
    y2: 81036.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B56A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3192"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbMonogramma);
export default __webpack_public_path__ + "static/media/KB-monogramma.25af5767fb26c4a5ccf11bd84eb2bb5a.svg";
export { ForwardRef as ReactComponent };